import React from 'react';
import { Modal } from '../../Modal';

const CommonModal = ({
  children = undefined,
  component = undefined,
  visible,
  modalClassName = '',
  ...rest
}) => {
  const Component = component;
  return (
    <React.Fragment>
      {visible && (
        <Modal
          modalRoot='root'
          modalState={visible}
          modalClassName={modalClassName}
        >
          {children ? children : <Component {...rest} />}
        </Modal>
      )}
    </React.Fragment>
  );
};

export default CommonModal;



// WEBPACK FOOTER //
// ./src/components/modals/common/Modal.jsx